import { graphql, setupWorker } from 'msw';
import {
  handleAddUser,
  handleGetDirectory,
  handleGetFile,
  handleGetProblemFiles,
  handleGetUserManagementData,
  handleMoveFile,
  handleRenameFile,
} from './mocks';
import { gqlHandlers } from './msw-dev-handlers.generated';
import './mocks';

const worker = setupWorker(
  ...gqlHandlers,
  graphql.query('GetDirectory', handleGetDirectory),
  graphql.query('GetFile', handleGetFile),
  graphql.query('GetUserManagementData', handleGetUserManagementData),
  graphql.query('GetProblemFiles', handleGetProblemFiles),
  graphql.mutation('RenameFile', handleRenameFile),
  graphql.mutation('MoveFile', handleMoveFile),
  graphql.mutation('AddUser', handleAddUser)
);

worker.start({ onUnhandledRequest: 'bypass' });
